import React, { useState } from 'react';
import { UploadIcon, RefreshCwIcon, LinkIcon, UserPlusIcon, MailIcon, TrashIcon, EditIcon, ShieldCheckIcon, AlertTriangleIcon, CheckCircleIcon, XIcon, CreditCardIcon, FileTextIcon, DownloadIcon, CheckIcon, CalendarIcon, TrendingUpIcon } from 'lucide-react';
interface User {
  id: number;
  name: string;
  lastName: string;
  email: string;
  phone?: string;
  position?: string;
  company: string;
  role: string;
  initials: string;
}
interface Invoice {
  id: string;
  date: string;
  amount: number;
  status: 'paid' | 'pending' | 'failed';
  plan: string;
  period: string;
  downloadUrl: string;
}
const Settings = () => {
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showChangePlanModal, setShowChangePlanModal] = useState(false);
  const [showUpdateCardModal, setShowUpdateCardModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState<number | null>(null);
  const [userToEdit, setUserToEdit] = useState<User | null>(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  // Subscription data
  const [currentPlan, setCurrentPlan] = useState({
    name: 'Profesional',
    price: 2499,
    billingCycle: 'monthly',
    nextBillingDate: '2024-02-15',
    status: 'active'
  });
  const [paymentMethod, setPaymentMethod] = useState({
    type: 'visa',
    last4: '4242',
    expiryMonth: '12',
    expiryYear: '2025',
    holderName: 'Ana Beltrán'
  });
  const [invoices, setInvoices] = useState<Invoice[]>([{
    id: 'INV-2024-001',
    date: '2024-01-15',
    amount: 2499,
    status: 'paid',
    plan: 'Profesional',
    period: 'Enero 2024',
    downloadUrl: '/invoices/INV-2024-001.pdf'
  }, {
    id: 'INV-2023-012',
    date: '2023-12-15',
    amount: 2499,
    status: 'paid',
    plan: 'Profesional',
    period: 'Diciembre 2023',
    downloadUrl: '/invoices/INV-2023-012.pdf'
  }, {
    id: 'INV-2023-011',
    date: '2023-11-15',
    amount: 2499,
    status: 'paid',
    plan: 'Profesional',
    period: 'Noviembre 2023',
    downloadUrl: '/invoices/INV-2023-011.pdf'
  }, {
    id: 'INV-2023-010',
    date: '2023-10-15',
    amount: 999,
    status: 'paid',
    plan: 'Starter',
    period: 'Octubre 2023',
    downloadUrl: '/invoices/INV-2023-010.pdf'
  }]);
  const [users, setUsers] = useState<User[]>([{
    id: 1,
    name: 'Ana',
    lastName: 'Beltrán',
    email: 'ana.beltran@pymesolutions.com',
    phone: '+52 55 1234 5678',
    position: 'Directora Financiera',
    company: 'PYME Solutions',
    role: 'Administrador',
    initials: 'AB'
  }, {
    id: 2,
    name: 'Laura',
    lastName: 'Torres',
    email: 'laura.torres@pymesolutions.com',
    company: 'PYME Solutions',
    role: 'Visualizador',
    initials: 'LT'
  }]);
  const [inviteData, setInviteData] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    company: '',
    role: 'Visualizador'
  });
  const [cardData, setCardData] = useState({
    number: '',
    holderName: '',
    expiryMonth: '',
    expiryYear: '',
    cvv: ''
  });
  const handleInviteUser = () => {
    if (inviteData.name && inviteData.lastName && inviteData.email) {
      const newUser: User = {
        id: users.length + 1,
        name: inviteData.name,
        lastName: inviteData.lastName,
        email: inviteData.email,
        phone: inviteData.phone || undefined,
        position: inviteData.position || undefined,
        company: inviteData.company,
        role: inviteData.role,
        initials: `${inviteData.name[0]}${inviteData.lastName[0]}`.toUpperCase()
      };
      setUsers([...users, newUser]);
      setInviteData({
        name: '',
        lastName: '',
        email: '',
        phone: '',
        position: '',
        company: '',
        role: 'Visualizador'
      });
      setShowInviteModal(false);
    }
  };
  const handleEditUser = (user: User) => {
    setUserToEdit(user);
    setShowEditModal(true);
  };
  const handleUpdateUser = () => {
    if (userToEdit) {
      setUsers(users.map(u => u.id === userToEdit.id ? userToEdit : u));
      setShowEditModal(false);
      setUserToEdit(null);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
  };
  const handleRemoveUser = (userId: number) => {
    setUserToDelete(userId);
    setShowDeleteModal(true);
  };
  const confirmRemoveUser = () => {
    if (userToDelete) {
      setUsers(users.filter(user => user.id !== userToDelete));
      setShowDeleteModal(false);
      setUserToDelete(null);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    }
  };
  const handleUpdateCard = () => {
    // Simular actualización de tarjeta
    setPaymentMethod({
      ...paymentMethod,
      last4: cardData.number.slice(-4),
      expiryMonth: cardData.expiryMonth,
      expiryYear: cardData.expiryYear,
      holderName: cardData.holderName
    });
    setCardData({
      number: '',
      holderName: '',
      expiryMonth: '',
      expiryYear: '',
      cvv: ''
    });
    setShowUpdateCardModal(false);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };
  const handleChangePlan = (planName: string) => {
    const planPrices: {
      [key: string]: number;
    } = {
      Starter: 2499,
      Profesional: 5499,
      Enterprise: 0
    };
    setCurrentPlan({
      ...currentPlan,
      name: planName,
      price: planPrices[planName]
    });
    setShowChangePlanModal(false);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
  };
  const getRoleBadgeColor = (role: string) => {
    switch (role) {
      case 'Administrador':
        return 'bg-purple-100 text-purple-700';
      case 'Visualizador':
        return 'bg-gray-100 text-gray-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'paid':
        return <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium" data-id="element-1859">
            Pagado
          </span>;
      case 'pending':
        return <span className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium" data-id="element-1860">
            Pendiente
          </span>;
      case 'failed':
        return <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium" data-id="element-1861">
            Fallido
          </span>;
      default:
        return null;
    }
  };
  const getUserToDeleteName = () => {
    const user = users.find(u => u.id === userToDelete);
    return user ? `${user.name} ${user.lastName}` : '';
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  };
  return <div data-id="element-1862">
      {/* Success Toast */}
      {showSuccessToast && <div className="fixed top-4 right-4 z-50 animate-slide-in" data-id="element-1863">
          <div className="bg-white border border-green-200 rounded-lg shadow-lg p-4 flex items-center space-x-3 min-w-[300px]" data-id="element-1864">
            <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center" data-id="element-1865">
              <CheckCircleIcon size={20} className="text-green-600" data-id="element-1866" />
            </div>
            <div className="flex-1" data-id="element-1867">
              <p className="font-medium text-gray-900" data-id="element-1868">Cambios guardados</p>
              <p className="text-sm text-gray-500" data-id="element-1869">
                Los cambios se han guardado exitosamente
              </p>
            </div>
            <button onClick={() => setShowSuccessToast(false)} className="text-gray-400 hover:text-gray-600" data-id="element-1870">
              <XIcon size={18} data-id="element-1871" />
            </button>
          </div>
        </div>}
      <div className="mb-6" data-id="element-1872">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-1873">Configuración</h1>
        <p className="text-gray-600" data-id="element-1874">
          Gestiona tu suscripción, integraciones y preferencias
        </p>
      </div>
      {/* Subscription Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-1875">
        <div className="flex items-center justify-between mb-6" data-id="element-1876">
          <div data-id="element-1877">
            <h2 className="text-lg font-semibold" data-id="element-1878">Plan y suscripción</h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-1879">
              Administra tu plan y facturación
            </p>
          </div>
          <div className="flex items-center space-x-2" data-id="element-1880">
            <div className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium" data-id="element-1881">
              {currentPlan.status === 'active' ? 'Activo' : 'Inactivo'}
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-1882">
          <div className="p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-100" data-id="element-1883">
            <div className="flex items-center space-x-2 mb-2" data-id="element-1884">
              <TrendingUpIcon size={20} className="text-blue-600" data-id="element-1885" />
              <p className="text-sm text-gray-600" data-id="element-1886">Plan actual</p>
            </div>
            <p className="text-2xl font-bold text-gray-900" data-id="element-1887">
              {currentPlan.name}
            </p>
            <p className="text-sm text-gray-600 mt-1" data-id="element-1888">
              {formatCurrency(currentPlan.price)}/mes
            </p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1889">
            <div className="flex items-center space-x-2 mb-2" data-id="element-1890">
              <CalendarIcon size={20} className="text-gray-600" data-id="element-1891" />
              <p className="text-sm text-gray-600" data-id="element-1892">Próxima renovación</p>
            </div>
            <p className="text-lg font-semibold text-gray-900" data-id="element-1893">
              {formatDate(currentPlan.nextBillingDate)}
            </p>
            <p className="text-sm text-gray-600 mt-1" data-id="element-1894">Renovación automática</p>
          </div>
          <div className="p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-1895">
            <div className="flex items-center space-x-2 mb-2" data-id="element-1896">
              <CreditCardIcon size={20} className="text-gray-600" data-id="element-1897" />
              <p className="text-sm text-gray-600" data-id="element-1898">Método de pago</p>
            </div>
            <p className="text-lg font-semibold text-gray-900" data-id="element-1899">
              •••• {paymentMethod.last4}
            </p>
            <p className="text-sm text-gray-600 mt-1" data-id="element-1900">
              Vence {paymentMethod.expiryMonth}/{paymentMethod.expiryYear}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap gap-3" data-id="element-1901">
          <button onClick={() => setShowChangePlanModal(true)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1902">
            Cambiar plan
          </button>
          <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1903">
            Cancelar suscripción
          </button>
        </div>
      </div>
      {/* Payment Method Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-1904">
        <div className="flex items-center justify-between mb-4" data-id="element-1905">
          <div data-id="element-1906">
            <h2 className="text-lg font-semibold" data-id="element-1907">Método de pago</h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-1908">
              Tarjeta utilizada para el cobro de tu suscripción
            </p>
          </div>
        </div>
        <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg mb-4" data-id="element-1909">
          <div className="flex items-center space-x-4" data-id="element-1910">
            <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center" data-id="element-1911">
              <CreditCardIcon size={24} className="text-white" data-id="element-1912" />
            </div>
            <div data-id="element-1913">
              <p className="font-medium text-gray-900" data-id="element-1914">
                {paymentMethod.type.toUpperCase()} •••• {paymentMethod.last4}
              </p>
              <p className="text-sm text-gray-500" data-id="element-1915">
                {paymentMethod.holderName} • Vence {paymentMethod.expiryMonth}/
                {paymentMethod.expiryYear}
              </p>
            </div>
          </div>
          <button onClick={() => setShowUpdateCardModal(true)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1916">
            Actualizar
          </button>
        </div>
        <div className="flex items-start space-x-2 p-3 bg-blue-50 border border-blue-100 rounded-lg" data-id="element-1917">
          <ShieldCheckIcon size={18} className="text-blue-600 mt-0.5" data-id="element-1918" />
          <div className="text-sm text-blue-900" data-id="element-1919">
            <p className="font-medium" data-id="element-1920">Pago seguro</p>
            <p className="text-blue-700" data-id="element-1921">
              Tu información de pago está encriptada y protegida con los más
              altos estándares de seguridad.
            </p>
          </div>
        </div>
      </div>
      {/* Invoices Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-1922">
        <div className="flex items-center justify-between mb-4" data-id="element-1923">
          <div data-id="element-1924">
            <h2 className="text-lg font-semibold" data-id="element-1925">Historial de facturas</h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-1926">
              Descarga tus facturas y comprobantes de pago
            </p>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1927">
          <table className="w-full" data-id="element-1928">
            <thead data-id="element-1929">
              <tr className="border-b border-gray-200" data-id="element-1930">
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1931">
                  Factura
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1932">
                  Fecha
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1933">
                  Plan
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1934">
                  Período
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1935">
                  Monto
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1936">
                  Estado
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700" data-id="element-1937">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1938">
              {invoices.map(invoice => <tr key={invoice.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-1939">
                  <td className="py-4 px-4" data-id="element-1940">
                    <div className="flex items-center space-x-2" data-id="element-1941">
                      <FileTextIcon size={16} className="text-gray-400" data-id="element-1942" />
                      <span className="font-medium text-gray-900" data-id="element-1943">
                        {invoice.id}
                      </span>
                    </div>
                  </td>
                  <td className="py-4 px-4 text-gray-600" data-id="element-1944">
                    {formatDate(invoice.date)}
                  </td>
                  <td className="py-4 px-4 text-gray-600" data-id="element-1945">{invoice.plan}</td>
                  <td className="py-4 px-4 text-gray-600" data-id="element-1946">{invoice.period}</td>
                  <td className="py-4 px-4 font-medium text-gray-900" data-id="element-1947">
                    {formatCurrency(invoice.amount)}
                  </td>
                  <td className="py-4 px-4" data-id="element-1948">
                    {getStatusBadge(invoice.status)}
                  </td>
                  <td className="py-4 px-4" data-id="element-1949">
                    <button className="flex items-center space-x-1 text-blue-600 hover:text-blue-700 transition-colors" data-id="element-1950">
                      <DownloadIcon size={16} data-id="element-1951" />
                      <span className="text-sm" data-id="element-1952">Descargar</span>
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
      {/* Change Plan Modal */}
      {showChangePlanModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1953">
          <div className="bg-white rounded-xl p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto" data-id="element-1954">
            <h3 className="text-xl font-semibold mb-6" data-id="element-1955">Cambiar plan</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-1956">
              {/* Starter Plan */}
              <div className={`p-6 rounded-xl border-2 ${currentPlan.name === 'Starter' ? 'border-blue-600 bg-blue-50' : 'border-gray-200'} cursor-pointer hover:border-blue-300 transition-colors`} onClick={() => handleChangePlan('Starter')} data-id="element-1957">
                <h4 className="text-xl font-bold mb-2" data-id="element-1958">Starter</h4>
                <p className="text-3xl font-bold mb-4" data-id="element-1959">
                  {formatCurrency(999)}
                  <span className="text-sm text-gray-500 font-normal" data-id="element-1960">
                    /mes
                  </span>
                </p>
                <ul className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-1961">
                  <li className="flex items-center space-x-2" data-id="element-1962">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1963" />
                    <span data-id="element-1964">Hasta 3 usuarios</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-1965">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1966" />
                    <span data-id="element-1967">Reportes básicos</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-1968">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1969" />
                    <span data-id="element-1970">Actualizaciones mensuales</span>
                  </li>
                </ul>
                {currentPlan.name === 'Starter' && <div className="text-sm text-blue-600 font-medium" data-id="element-1971">
                    Plan actual
                  </div>}
              </div>
              {/* Professional Plan */}
              <div className={`p-6 rounded-xl border-2 ${currentPlan.name === 'Profesional' ? 'border-blue-600 bg-blue-50' : 'border-gray-200'} cursor-pointer hover:border-blue-300 transition-colors relative`} onClick={() => handleChangePlan('Profesional')} data-id="element-1972">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2" data-id="element-1973">
                  <span className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-3 py-1 rounded-full text-xs font-medium" data-id="element-1974">
                    Más popular
                  </span>
                </div>
                <h4 className="text-xl font-bold mb-2" data-id="element-1975">Profesional</h4>
                <p className="text-3xl font-bold mb-4" data-id="element-1976">
                  {formatCurrency(2499)}
                  <span className="text-sm text-gray-500 font-normal" data-id="element-1977">
                    /mes
                  </span>
                </p>
                <ul className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-1978">
                  <li className="flex items-center space-x-2" data-id="element-1979">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1980" />
                    <span data-id="element-1981">Hasta 10 usuarios</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-1982">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1983" />
                    <span data-id="element-1984">Reportes avanzados</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-1985">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1986" />
                    <span data-id="element-1987">Tiempo real</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-1988">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1989" />
                    <span data-id="element-1990">Análisis predictivo</span>
                  </li>
                </ul>
                {currentPlan.name === 'Profesional' && <div className="text-sm text-blue-600 font-medium" data-id="element-1991">
                    Plan actual
                  </div>}
              </div>
              {/* Enterprise Plan */}
              <div className={`p-6 rounded-xl border-2 ${currentPlan.name === 'Enterprise' ? 'border-blue-600 bg-blue-50' : 'border-gray-200'} cursor-pointer hover:border-blue-300 transition-colors`} data-id="element-1992">
                <h4 className="text-xl font-bold mb-2" data-id="element-1993">Enterprise</h4>
                <p className="text-3xl font-bold mb-4" data-id="element-1994">Personalizado</p>
                <ul className="space-y-2 text-sm text-gray-600 mb-4" data-id="element-1995">
                  <li className="flex items-center space-x-2" data-id="element-1996">
                    <CheckIcon size={16} className="text-green-600" data-id="element-1997" />
                    <span data-id="element-1998">Usuarios ilimitados</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-1999">
                    <CheckIcon size={16} className="text-green-600" data-id="element-2000" />
                    <span data-id="element-2001">Reportes personalizados</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-2002">
                    <CheckIcon size={16} className="text-green-600" data-id="element-2003" />
                    <span data-id="element-2004">Soporte 24/7</span>
                  </li>
                  <li className="flex items-center space-x-2" data-id="element-2005">
                    <CheckIcon size={16} className="text-green-600" data-id="element-2006" />
                    <span data-id="element-2007">Integraciones custom</span>
                  </li>
                </ul>
                <button className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-2008">
                  Contactar ventas
                </button>
              </div>
            </div>
            <div className="flex justify-end space-x-3" data-id="element-2009">
              <button onClick={() => setShowChangePlanModal(false)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2010">
                Cancelar
              </button>
            </div>
          </div>
        </div>}
      {/* Update Card Modal */}
      {showUpdateCardModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2011">
          <div className="bg-white rounded-xl p-6 max-w-md w-full" data-id="element-2012">
            <h3 className="text-xl font-semibold mb-4" data-id="element-2013">
              Actualizar método de pago
            </h3>
            <div className="space-y-4" data-id="element-2014">
              <div data-id="element-2015">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2016">
                  Número de tarjeta
                </label>
                <input type="text" value={cardData.number} onChange={e => setCardData({
              ...cardData,
              number: e.target.value
            })} placeholder="1234 5678 9012 3456" maxLength={19} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2017" />
              </div>
              <div data-id="element-2018">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2019">
                  Nombre del titular
                </label>
                <input type="text" value={cardData.holderName} onChange={e => setCardData({
              ...cardData,
              holderName: e.target.value
            })} placeholder="Ana Beltrán" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2020" />
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-2021">
                <div data-id="element-2022">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2023">
                    Mes
                  </label>
                  <input type="text" value={cardData.expiryMonth} onChange={e => setCardData({
                ...cardData,
                expiryMonth: e.target.value
              })} placeholder="12" maxLength={2} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2024" />
                </div>
                <div data-id="element-2025">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2026">
                    Año
                  </label>
                  <input type="text" value={cardData.expiryYear} onChange={e => setCardData({
                ...cardData,
                expiryYear: e.target.value
              })} placeholder="2025" maxLength={4} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2027" />
                </div>
                <div data-id="element-2028">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2029">
                    CVV
                  </label>
                  <input type="text" value={cardData.cvv} onChange={e => setCardData({
                ...cardData,
                cvv: e.target.value
              })} placeholder="123" maxLength={4} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2030" />
                </div>
              </div>
              <div className="flex items-start space-x-2 p-3 bg-blue-50 border border-blue-100 rounded-lg" data-id="element-2031">
                <ShieldCheckIcon size={16} className="text-blue-600 mt-0.5" data-id="element-2032" />
                <p className="text-xs text-blue-900" data-id="element-2033">
                  Tu información está protegida con encriptación de nivel
                  bancario
                </p>
              </div>
            </div>
            <div className="flex justify-end space-x-3 mt-6" data-id="element-2034">
              <button onClick={() => setShowUpdateCardModal(false)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2035">
                Cancelar
              </button>
              <button onClick={handleUpdateCard} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-2036">
                Actualizar tarjeta
              </button>
            </div>
          </div>
        </div>}
      {/* User Access Management Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-2037">
        <div className="flex items-center justify-between mb-4" data-id="element-2038">
          <div data-id="element-2039">
            <h2 className="text-lg font-semibold" data-id="element-2040">Gestión de accesos</h2>
            <p className="text-sm text-gray-500 mt-1" data-id="element-2041">
              Administra quién tiene acceso a tu cuenta
            </p>
          </div>
          <button onClick={() => setShowInviteModal(true)} className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-2042">
            <UserPlusIcon size={16} data-id="element-2043" />
            <span data-id="element-2044">Invitar usuario</span>
          </button>
        </div>
        {/* Users List */}
        <div className="space-y-3 mt-6" data-id="element-2045">
          {users.map(user => <div key={user.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors" data-id="element-2046">
              <div className="flex items-center space-x-4" data-id="element-2047">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center bg-blue-100`} data-id="element-2048">
                  <span className={`font-medium text-sm text-blue-600`} data-id="element-2049">
                    {user.initials}
                  </span>
                </div>
                <div data-id="element-2050">
                  <div className="flex items-center space-x-2" data-id="element-2051">
                    <h3 className="font-medium text-gray-900" data-id="element-2052">
                      {user.name} {user.lastName}
                    </h3>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-2053">{user.email}</p>
                </div>
              </div>
              <div className="flex items-center space-x-3" data-id="element-2054">
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${getRoleBadgeColor(user.role)}`} data-id="element-2055">
                  {user.role}
                </span>
              </div>
            </div>)}
        </div>
        {/* Role Descriptions */}
        <div className="mt-6 p-4 bg-gray-50 rounded-lg" data-id="element-2056">
          <h3 className="text-sm font-semibold text-gray-700 mb-3" data-id="element-2057">
            Descripción de roles
          </h3>
          <div className="space-y-2 text-sm text-gray-600" data-id="element-2058">
            <div className="flex items-start" data-id="element-2059">
              <span className="font-medium w-32" data-id="element-2060">Administrador:</span>
              <span data-id="element-2061">
                Acceso completo a su empresa, puede gestionar usuarios y
                configuración
              </span>
            </div>
            <div className="flex items-start" data-id="element-2062">
              <span className="font-medium w-32" data-id="element-2063">Visualizador:</span>
              <span data-id="element-2064">Solo puede ver reportes, sin permisos de edición</span>
            </div>
          </div>
        </div>
      </div>
      {/* Edit User Modal */}
      {showEditModal && userToEdit && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2065">
          <div className="bg-white rounded-xl p-6 max-w-md w-full max-h-[90vh] overflow-y-auto" data-id="element-2066">
            <h3 className="text-xl font-semibold mb-4" data-id="element-2067">Editar usuario</h3>
            <div className="space-y-4" data-id="element-2068">
              <div className="grid grid-cols-2 gap-4" data-id="element-2069">
                <div data-id="element-2070">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2071">
                    Nombre
                  </label>
                  <input type="text" value={userToEdit.name} onChange={e => setUserToEdit({
                ...userToEdit,
                name: e.target.value
              })} placeholder="Juan" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2072" />
                </div>
                <div data-id="element-2073">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2074">
                    Apellidos
                  </label>
                  <input type="text" value={userToEdit.lastName} onChange={e => setUserToEdit({
                ...userToEdit,
                lastName: e.target.value
              })} placeholder="Pérez" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2075" />
                </div>
              </div>
              <div data-id="element-2076">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2077">
                  Correo electrónico
                </label>
                <input type="email" value={userToEdit.email} onChange={e => setUserToEdit({
              ...userToEdit,
              email: e.target.value
            })} placeholder="juan@empresa.com" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2078" />
              </div>
              <div data-id="element-2079">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2080">
                  Teléfono{' '}
                  <span className="text-gray-400 text-xs" data-id="element-2081">(opcional)</span>
                </label>
                <input type="tel" value={userToEdit.phone || ''} onChange={e => setUserToEdit({
              ...userToEdit,
              phone: e.target.value
            })} placeholder="+52 55 1234 5678" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2082" />
              </div>
              <div data-id="element-2083">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2084">
                  Cargo{' '}
                  <span className="text-gray-400 text-xs" data-id="element-2085">(opcional)</span>
                </label>
                <input type="text" value={userToEdit.position || ''} onChange={e => setUserToEdit({
              ...userToEdit,
              position: e.target.value
            })} placeholder="Director Financiero" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2086" />
              </div>
              <div data-id="element-2087">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2088">
                  Rol
                </label>
                <select value={userToEdit.role} onChange={e => setUserToEdit({
              ...userToEdit,
              role: e.target.value
            })} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2089">
                  <option value="Visualizador" data-id="element-2090">Visualizador</option>
                  <option value="Administrador" data-id="element-2091">Administrador</option>
                </select>
              </div>
              {(userToEdit.role === 'Visualizador' || userToEdit.role === 'Administrador') && <div data-id="element-2092">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2093">
                    Empresa
                  </label>
                  <select value={userToEdit.company} onChange={e => setUserToEdit({
              ...userToEdit,
              company: e.target.value
            })} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2094">
                    <option value="" data-id="element-2095">Seleccionar empresa</option>
                    <option value="PYME Solutions" data-id="element-2096">PYME Solutions</option>
                    <option value="Retail Express" data-id="element-2097">Retail Express</option>
                    <option value="Manufacturing Pro" data-id="element-2098">Manufacturing Pro</option>
                    <option value="Services Plus" data-id="element-2099">Services Plus</option>
                  </select>
                </div>}
            </div>
            <div className="flex justify-end space-x-3 mt-6" data-id="element-2100">
              <button onClick={() => {
            setShowEditModal(false);
            setUserToEdit(null);
          }} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2101">
                Cancelar
              </button>
              <button onClick={handleUpdateUser} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-2102">
                Guardar cambios
              </button>
            </div>
          </div>
        </div>}
      {/* Delete Confirmation Modal */}
      {showDeleteModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-2103">
          <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4" data-id="element-2104">
            <div className="flex items-center space-x-3 mb-4" data-id="element-2105">
              <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center" data-id="element-2106">
                <AlertTriangleIcon size={24} className="text-red-600" data-id="element-2107" />
              </div>
              <div data-id="element-2108">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2109">
                  Eliminar acceso
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2110">
                  Esta acción no se puede deshacer
                </p>
              </div>
            </div>
            <p className="text-gray-700 mb-6" data-id="element-2111">
              ¿Estás seguro de que deseas eliminar el acceso de{' '}
              <span className="font-medium" data-id="element-2112">{getUserToDeleteName()}</span>? Esta
              persona ya no podrá acceder a la plataforma.
            </p>
            <div className="flex justify-end space-x-3" data-id="element-2113">
              <button onClick={() => {
            setShowDeleteModal(false);
            setUserToDelete(null);
          }} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-2114">
                Cancelar
              </button>
              <button onClick={confirmRemoveUser} className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors" data-id="element-2115">
                Eliminar acceso
              </button>
            </div>
          </div>
        </div>}
      {/* Invite Modal */}
      {showInviteModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-2116">
          <div className="bg-white rounded-xl p-6 max-w-md w-full max-h-[90vh] overflow-y-auto" data-id="element-2117">
            <h3 className="text-xl font-semibold mb-4" data-id="element-2118">
              Invitar nuevo usuario
            </h3>
            <div className="space-y-4" data-id="element-2119">
              <div className="grid grid-cols-2 gap-4" data-id="element-2120">
                <div data-id="element-2121">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2122">
                    Nombre
                  </label>
                  <input type="text" value={inviteData.name} onChange={e => setInviteData({
                ...inviteData,
                name: e.target.value
              })} placeholder="Juan" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2123" />
                </div>
                <div data-id="element-2124">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2125">
                    Apellidos
                  </label>
                  <input type="text" value={inviteData.lastName} onChange={e => setInviteData({
                ...inviteData,
                lastName: e.target.value
              })} placeholder="Pérez" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2126" />
                </div>
              </div>
              <div data-id="element-2127">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2128">
                  Correo electrónico
                </label>
                <input type="email" value={inviteData.email} onChange={e => setInviteData({
              ...inviteData,
              email: e.target.value
            })} placeholder="juan@empresa.com" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2129" />
              </div>
              <div data-id="element-2130">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2131">
                  Teléfono{' '}
                  <span className="text-gray-400 text-xs" data-id="element-2132">(opcional)</span>
                </label>
                <input type="tel" value={inviteData.phone} onChange={e => setInviteData({
              ...inviteData,
              phone: e.target.value
            })} placeholder="+52 55 1234 5678" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2133" />
              </div>
              <div data-id="element-2134">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2135">
                  Cargo{' '}
                  <span className="text-gray-400 text-xs" data-id="element-2136">(opcional)</span>
                </label>
                <input type="text" value={inviteData.position} onChange={e => setInviteData({
              ...inviteData,
              position: e.target.value
            })} placeholder="Director Financiero" className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2137" />
              </div>
              <div data-id="element-2138">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2139">
                  Rol
                </label>
                <select value={inviteData.role} onChange={e => setInviteData({
              ...inviteData,
              role: e.target.value
            })} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2140">
                  <option value="Visualizador" data-id="element-2141">Visualizador</option>
                  <option value="Administrador" data-id="element-2142">Administrador</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2143">
                  Super Admin solo debe ser asignado a personal de FinancePro
                </p>
              </div>
              {(inviteData.role === 'Visualizador' || inviteData.role === 'Administrador') && <div data-id="element-2144">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2145">
                    Empresa
                  </label>
                  <select value={inviteData.company} onChange={e => setInviteData({
              ...inviteData,
              company: e.target.value
            })} className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" data-id="element-2146">
                    <option value="" data-id="element-2147">Seleccionar empresa</option>
                    <option value="PYME Solutions" data-id="element-2148">PYME Solutions</option>
                    <option value="Retail Express" data-id="element-2149">Retail Express</option>
                    <option value="Manufacturing Pro" data-id="element-2150">Manufacturing Pro</option>
                    <option value="Services Plus" data-id="element-2151">Services Plus</option>
                  </select>
                </div>}
            </div>
            <div className="flex justify-end space-x-3 mt-6" data-id="element-2152">
              <button onClick={() => setShowInviteModal(false)} className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2153">
                Cancelar
              </button>
              <button onClick={handleInviteUser} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-2154">
                Enviar invitación
              </button>
            </div>
          </div>
        </div>}
      {/* Email Templates Section */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-2155">
        <div className="flex items-center space-x-2 mb-4" data-id="element-2156">
          <MailIcon size={20} className="text-gray-600" data-id="element-2157" />
          <h2 className="text-lg font-semibold" data-id="element-2158">Plantillas de correo</h2>
        </div>
        <p className="text-sm text-gray-600 mb-4" data-id="element-2159">
          Vista previa de los correos electrónicos que se envían a tus usuarios
        </p>
        <div className="space-y-3" data-id="element-2160">
          <a href="/emails/welcome" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group" data-id="element-2161">
            <div className="flex items-center space-x-3" data-id="element-2162">
              <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center group-hover:bg-blue-200 transition-colors" data-id="element-2163">
                <MailIcon size={20} className="text-blue-600" data-id="element-2164" />
              </div>
              <div data-id="element-2165">
                <h3 className="font-medium text-gray-800" data-id="element-2166">
                  Correo de bienvenida
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2167">
                  Se envía cuando un usuario se registra
                </p>
              </div>
            </div>
            <span className="text-sm text-blue-600 group-hover:text-blue-700" data-id="element-2168">
              Ver plantilla →
            </span>
          </a>
          <a href="/emails/financial-reports" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group" data-id="element-2169">
            <div className="flex items-center space-x-3" data-id="element-2170">
              <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center group-hover:bg-green-200 transition-colors" data-id="element-2171">
                <MailIcon size={20} className="text-green-600" data-id="element-2172" />
              </div>
              <div data-id="element-2173">
                <h3 className="font-medium text-gray-800" data-id="element-2174">
                  Estados financieros listos
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2175">
                  Notifica cuando los reportes están disponibles
                </p>
              </div>
            </div>
            <span className="text-sm text-blue-600 group-hover:text-blue-700" data-id="element-2176">
              Ver plantilla →
            </span>
          </a>
          <a href="/emails/invoice" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group" data-id="element-2177">
            <div className="flex items-center space-x-3" data-id="element-2178">
              <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center group-hover:bg-purple-200 transition-colors" data-id="element-2179">
                <MailIcon size={20} className="text-purple-600" data-id="element-2180" />
              </div>
              <div data-id="element-2181">
                <h3 className="font-medium text-gray-800" data-id="element-2182">
                  Factura de cobranza
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2183">
                  Confirmación de pago con detalles de factura
                </p>
              </div>
            </div>
            <span className="text-sm text-blue-600 group-hover:text-blue-700" data-id="element-2184">
              Ver plantilla →
            </span>
          </a>
          <a href="/emails/alerts" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group" data-id="element-2185">
            <div className="flex items-center space-x-3" data-id="element-2186">
              <div className="w-10 h-10 rounded-lg bg-red-100 flex items-center justify-center group-hover:bg-red-200 transition-colors" data-id="element-2187">
                <MailIcon size={20} className="text-red-600" data-id="element-2188" />
              </div>
              <div data-id="element-2189">
                <h3 className="font-medium text-gray-800" data-id="element-2190">
                  Alertas y notificaciones importantes
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2191">
                  Alertas críticas que requieren atención
                </p>
              </div>
            </div>
            <span className="text-sm text-blue-600 group-hover:text-blue-700" data-id="element-2192">
              Ver plantilla →
            </span>
          </a>
          <a href="/emails/product-updates" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group" data-id="element-2193">
            <div className="flex items-center space-x-3" data-id="element-2194">
              <div className="w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center group-hover:bg-indigo-200 transition-colors" data-id="element-2195">
                <MailIcon size={20} className="text-indigo-600" data-id="element-2196" />
              </div>
              <div data-id="element-2197">
                <h3 className="font-medium text-gray-800" data-id="element-2198">
                  Actualizaciones del producto
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2199">
                  Nuevas funcionalidades y mejoras
                </p>
              </div>
            </div>
            <span className="text-sm text-blue-600 group-hover:text-blue-700" data-id="element-2200">
              Ver plantilla →
            </span>
          </a>
          <a href="/emails/financial-tips" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 transition-colors group" data-id="element-2201">
            <div className="flex items-center space-x-3" data-id="element-2202">
              <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center group-hover:bg-emerald-200 transition-colors" data-id="element-2203">
                <MailIcon size={20} className="text-emerald-600" data-id="element-2204" />
              </div>
              <div data-id="element-2205">
                <h3 className="font-medium text-gray-800" data-id="element-2206">
                  Noticias y consejos financieros
                </h3>
                <p className="text-sm text-gray-500" data-id="element-2207">
                  Newsletter mensual con tips y recursos
                </p>
              </div>
            </div>
            <span className="text-sm text-blue-600 group-hover:text-blue-700" data-id="element-2208">
              Ver plantilla →
            </span>
          </a>
        </div>
      </div>
      {/* Integration Settings */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm mb-6" data-id="element-2209">
        <h2 className="text-lg font-semibold mb-4" data-id="element-2210">Integraciones</h2>
        <div className="space-y-4" data-id="element-2211">
          <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-2212">
            <div className="flex items-center space-x-3" data-id="element-2213">
              <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center" data-id="element-2214">
                <LinkIcon size={20} className="text-green-600" data-id="element-2215" />
              </div>
              <div data-id="element-2216">
                <h3 className="font-medium" data-id="element-2217">QuickBooks</h3>
                <p className="text-sm text-gray-500" data-id="element-2218">
                  Conectado - Última sincronización: Hace 2 horas
                </p>
              </div>
            </div>
            <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-2219">
              Configurar
            </button>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-2220">
            <div className="flex items-center space-x-3" data-id="element-2221">
              <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-2222">
                <LinkIcon size={20} className="text-gray-400" data-id="element-2223" />
              </div>
              <div data-id="element-2224">
                <h3 className="font-medium" data-id="element-2225">Contalink</h3>
                <p className="text-sm text-gray-500" data-id="element-2226">No conectado</p>
              </div>
            </div>
            <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-2227">
              Conectar
            </button>
          </div>
          <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg" data-id="element-2228">
            <div className="flex items-center space-x-3" data-id="element-2229">
              <div className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center" data-id="element-2230">
                <LinkIcon size={20} className="text-gray-400" data-id="element-2231" />
              </div>
              <div data-id="element-2232">
                <h3 className="font-medium" data-id="element-2233">SAP</h3>
                <p className="text-sm text-gray-500" data-id="element-2234">No conectado</p>
              </div>
            </div>
            <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-2235">
              Conectar
            </button>
          </div>
        </div>
      </div>
      {/* Data Sync Settings */}
      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-2236">
        <h2 className="text-lg font-semibold mb-4" data-id="element-2237">Sincronización de datos</h2>
        <div className="space-y-4" data-id="element-2238">
          <div className="flex items-center justify-between" data-id="element-2239">
            <div data-id="element-2240">
              <h3 className="font-medium" data-id="element-2241">Sincronización automática</h3>
              <p className="text-sm text-gray-500" data-id="element-2242">
                Actualiza los datos cada 24 horas
              </p>
            </div>
            <label className="relative inline-flex items-center cursor-pointer" data-id="element-2243">
              <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-2244" />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-2245"></div>
            </label>
          </div>
          <div className="pt-4 border-t border-gray-200" data-id="element-2246">
            <button className="flex items-center space-x-2 text-sm text-blue-600 hover:text-blue-700" data-id="element-2247">
              <RefreshCwIcon size={16} data-id="element-2248" />
              <span data-id="element-2249">Sincronizar ahora</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default Settings;